let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1I4GK")).then(() => parcelRequire('etgUQ'));